
export const APPEND_FILTER = "APPEND_FILTER"

export const RESET_FILTER="RESET_FILTER"